import { render, staticRenderFns } from "./RelativeReturnMoney.vue?vue&type=template&id=5c448c1b&scoped=true"
import script from "./RelativeReturnMoney.vue?vue&type=script&lang=js"
export * from "./RelativeReturnMoney.vue?vue&type=script&lang=js"
import style0 from "./RelativeReturnMoney.vue?vue&type=style&index=0&id=5c448c1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c448c1b",
  null
  
)

export default component.exports